<template>
  <v-row>
    <Confirm
      :confirm.sync="confirmDelete"
      :callback="deleteElaborator"
      message="Are you sure you want to delete this elaborator?"
    ></Confirm>
    <v-speed-dial
      v-model="fab"
      :absolute="true"
      :top="true"
      :right="true"
      direction="bottom"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-plus-box-multiple</v-icon>
        </v-btn>
      </template>
      <v-btn fab light small @click="showList = !showList">
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
      <v-btn fab light small @click="newElaborator()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn
        fab
        light
        small
        @click="newElaborator(true)"
        title="Custom registration prompts"
        v-if="!hasCustomRegitrationPromptElaborator"
      >
        <v-icon>mdi-account-details</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="red"
        @click="confirmDelete = true"
        v-if="elaborator && elaborator.id"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-col class="px-6" cols="12" :md="showList ? 3 : 0" v-if="showList">
      <v-expansion-panels elevation="1" :value="0">
        <v-expansion-panel>
          <v-expansion-panel-header class="title">
            Elaborators
            <template v-slot:actions>
              <v-icon>mdi-alert-circle-outline</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>
              Elaborators are prompt sequences that propmt the user for more
              information, typically to elborate on a triggered action.
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-progress-linear
        indeterminate
        color="primary"
        v-if="elaboratorsLoading"
        height="7"
      ></v-progress-linear>
      <v-data-iterator
        :items="elaborators"
        item-key="id"
        :loading="elaboratorsLoading"
        :items-per-page.sync="limit"
        :server-items-length="totalElaborators"
        :page.sync="page"
        :footer-props="{
          'items-per-page-options': itemsPerPageArray,
          'items-per-page-text': '',
          'show-current-page': true,
        }"
        loading-text="Loading elaborators..."
        no-results-text="You have not created any elaborators yet."
      >
        <template v-slot:default="props">
          <v-list elevation="1">
            <v-list-item-group v-model="selected" color="primary">
              <v-list-item two-line v-for="item in props.items" :key="item._id">
                <v-list-item-icon>
                  <v-icon>mdi-message</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.description
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </template>
      </v-data-iterator>
    </v-col>
    <v-col class="px-6" cols="12" :md="showList ? 9 : 12">
      <Elaborator
        :elaborator="elaborator"
        :groups="groups"
        :canBeCustomRegitrationPromptElaborator="
          !hasCustomRegitrationPromptElaborator
        "
        :customRegitrationPromptElaborator="customRegitrationPromptElaborator"
        v-if="elaborator"
      ></Elaborator>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
import { models, makeFindMixin } from "feathers-vuex";
import Elaborator from "@/components/elaborators/Elaborator";
import Confirm from "@/components/widget/Confirm";

export default {
  data: () => ({
    itemsPerPageArray: [5, 10, 20, 30, 50, -1],
    page: 1,
    limit: 10,
    skip: 0,
    pagination: {
      rowsPerPage: 5,
    },
    fab: null,
    showList: true,
    selected: null,
    elaborator: null,
    confirmDelete: false,
  }),
  mixins: [
    makeFindMixin({ service: "elaborators", watch: true }),
    makeFindMixin({ service: "groups" }),
  ],
  async mounted() {
    this.newElaborator();
  },
  computed: {
    elaboratorsLoading() {
      return this.isFindElaboratorsPending;
    },
    totalElaborators() {
      return this.elaboratorsPaginationData.default &&
        this.elaboratorsPaginationData.default.mostRecent.total
        ? this.elaboratorsPaginationData.default.mostRecent.total
        : 0;
    },
    elaboratorsParams() {
      return {
        query: {
          $limit: this.limit !== -1 ? this.limit : this.totalActions,
          $skip: this.skip,
        },
      };
    },
    groupsParams() {
      return { query: {} };
    },
    customRegitrationPromptElaborator() {
      return this.elaborators.find(
        (elaborator) => elaborator.properties.forCustomRegistrationPrompts
      );
    },
    hasCustomRegitrationPromptElaborator() {
      return this.elaborators.find(
        (elaborator) => elaborator.properties.forCustomRegistrationPrompts
      )
        ? true
        : false;
    },
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    newElaborator(isCustom) {
      const { Elaborator } = models.bot;
      this.elaborator = new Elaborator();

      if (isCustom) {
        this.elaborator.name = "Custom Registration Prompts";
        this.elaborator.properties.forCustomRegistrationPrompts = true;
      }
    },
    async deleteElaborator() {
      if (this.elaborator && this.elaborator.id) {
        try {
          await this.elaborator.remove();
          this.showMessage({ text: "Elaborator deleted!", color: "green" });
          this.newElaborator();
        } catch (error) {
          this.error = error;
          this.showMessage({
            text: error.message || "Error occured!",
            color: "red",
          });
        }
      }
    },
  },
  components: {
    Elaborator,
    Confirm,
  },
  watch: {
    page(now) {
      this.skip = now * this.limit - this.limit;
      this.newElaborator();
      this.selected = null;
    },
    isFindElaboratorsPending(pending) {
      if (pending) return;

      if (
        this.$route.params.custom &&
        !this.hasCustomRegitrationPromptElaborator
      ) {
        this.newElaborator(this.$route.params.custom);
      } else if (
        this.$route.params.custom &&
        this.hasCustomRegitrationPromptElaborator
      ) {
        this.selected = this.elaborators.findIndex(
          (elaborator) => elaborator.properties.forCustomRegistrationPrompts
        );
      }
    },
    selected(item) {
      if (
        this.selected !== undefined &&
        this.selected !== null &&
        this.elaborators &&
        this.elaborators[item]
      ) {
        this.elaborator = this.elaborators[item].clone();
      } else if (this.selected === undefined) {
        this.elaborator = null;
      }
    },
    elaborator(item) {
      if (
        this.selected !== undefined &&
        this.selected !== null &&
        this.elaborators &&
        this.elaborators[this.selected] &&
        this.elaborators[this.selected].id !== item.id
      ) {
        this.selected = null;
      } else if (
        (this.selected === undefined || this.selected === null) &&
        item &&
        item.id
      ) {
        this.selected = this.elaborators.length - 1;
      }
    },
  },
};
</script>